import PostProcessRT from './postProcessRT'
import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Mouse from '@/js/utils/mouse'

import ShaderManifest from '../shaderManifest'
import DebugController from '@/glxp/debug/debugController'

const VERTICES = [-1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0]
const INDICES = [0, 1, 2, 0, 2, 3]
const UVS = [0, 1, 0, 0, 1, 0, 1, 1]

const BLUR_PASSES_HD = [ [20, 0],  [0, 20], [10, 0],  [0, 10], [6.6, 0],  [0, 7], [3.5, 0],  [0, 3.5], [1, 0],  [0, 1]]
const BLUR_PASSES_SD = [ [15, 0],  [0, 15], [10, 0],  [0, 10], [3.5, 0],  [0, 3.5], [1, 0],  [0, 1],]
const BLUR_PASSES_LD = [ [10, 0],  [0, 10], [3, 0],  [0, 3], [1, 0],  [0, 1],]

let BLUR_PASSES

class Blur extends Rendable {
    constructor(scene, parent) {
        super(scene)
        this.hasNormal = false

        this.parent = parent
        this.direction = [0, 0]

        var shader = new Shader(ShaderManifest['post-halo'], 2)

        this.initProgram(shader.vert, shader.passes[0])
        this.initBuffer({
            vertices: VERTICES,
            uvs: UVS,
            indices: INDICES
        })
        this.initVao()
        this.createUniforms()

        this.activeRt = 0
        this.disabledRt = 1

        if (this.scene.manager.GPUTier.tier == "GPU_DESKTOP_TIER_3") {
            BLUR_PASSES = BLUR_PASSES_HD
        } else if (this.scene.manager.GPUTier.tier == "GPU_DESKTOP_TIER_2") {
            BLUR_PASSES = BLUR_PASSES_SD
        } else {
            BLUR_PASSES = BLUR_PASSES_LD
        }

        this.rts = [
            new PostProcessRT(this.scene, 0.2),
            new PostProcessRT(this.scene, 0.2)
        ]

    }

    createUniforms() {
        this.createUniform('uTexture', 'texture')
        this.createUniform('uRez', 'float2')
        this.createUniform('uDir', 'float2')
    }

    applyState() {
        let gl = this.gl
        this.scene.applyDefaultState()
        gl.disable(gl.DEPTH_TEST)
    }

    preRender() {
        this.rts[this.disabledRt].preRender()
    }

    postRender() {
        this.rts[this.disabledRt].postRender()
        this.activeRt = this.activeRt === 1 ? 0 : 1
        this.disabledRt = this.disabledRt === 1 ? 0 : 1
    }

    bind() {
        this.rts[this.activeRt].bind()
    }

    render() {
        let gl = this.gl

        
        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()
        
        this.preRender()

        this.bindUniform('uRez', [this.scene.width, this.scene.height])
        this.direction = BLUR_PASSES[0]
        this.bindUniform('uDir', this.direction)
        
        gl.activeTexture(gl.TEXTURE0)
        this.parent.rt.bind()
        this.bindUniform('uTexture', 0)
        
        gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
        
        this.postRender()
        
        for (let i = 1; i < BLUR_PASSES.length; i++) {
            this.preRender()
            
            this.direction = BLUR_PASSES[i]
            this.bindUniform('uDir', this.direction)
            gl.activeTexture(gl.TEXTURE0)
            this.rts[this.activeRt].bind()
            this.bindUniform('uTexture', 0)

            gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)

            this.postRender()
        }

        gl.bindVertexArray(null)
        gl.bindFramebuffer(gl.FRAMEBUFFER, null)
        
    }
}


class Post extends Rendable {
    constructor(scene) {
        super(scene)
        this.hasNormal = false
        // this.onlyVertices = false

        var shader = new Shader(ShaderManifest['post-halo'], 2)

        this.initProgram(shader.vert, shader.frag)
        this.initBuffer({
            vertices: VERTICES,
            uvs: UVS,
            indices: INDICES
        })
        this.initVao()
        this.createUniforms()

        this.blur = new Blur(this.scene, this)
        this.rt = new PostProcessRT(this.scene)

        this.power = 0.2

        // this.config = {
        //     power: { value: 0.5, range: [0, 1] },
        // }

        // DebugController.addConfig(this.config, 'Halo')
    }

    createUniforms() {
        this.createUniform('uBlur', 'texture')
        this.createUniform('uRez', 'float2')
        this.createUniform('uPower')
        this.createUniform('uTime')
    }

    applyState() {
        let gl = this.gl
        this.scene.applyDefaultState()
        gl.disable(gl.DEPTH_TEST)
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_COLOR);
    }

    preRender() {
        this.rt.preRender()
    }

    postRender() {
        this.rt.postRender()
    }

    render() {

        if (this.power <= 0.01) {
            return
        }
        let gl = this.gl

        this.blur.render()
        this.gl.viewport(0, 0, this.scene.width, this.scene.height)

        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()

        gl.activeTexture(gl.TEXTURE0)
        this.blur.bind()
        this.bindUniform('uBlur', 0)

        this.bindUniform('uRez', [this.scene.width, this.scene.height])
        this.bindUniform('uPower', this.power)
        this.bindUniform('uTime', this.scene.time % 100)

        gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
        gl.bindVertexArray(null)
    }
}

export default Post
